function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M250 0L30.7666 0.0144777L0 64.5161H219.515L250 0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.381 3.0094L139.317 3.02388L111.549 61.0622L5.59323 61.0346L33.381 3.0094Z",
  fill: "#D9E7AF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.318 3.02392L245.123 3.00928L217.336 61.0345H111.548L139.318 3.02392Z",
  fill: "#FCD8CA"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.1109 3.0094H39.3231L11.5354 61.0346H5.32364L33.1109 3.0094Z",
  fill: "#009035"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.2229 3.0094H47.4345L19.6468 61.0346H13.4352L41.2229 3.0094Z",
  fill: "#009035"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49.3345 3.0094H55.5462L27.7588 61.0346H21.5466L49.3345 3.0094Z",
  fill: "#009035"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.4463 3.0094H63.6583L35.8706 61.0346H29.6589L57.4463 3.0094V3.0094Z",
  fill: "#009035"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M65.5582 3.0094H71.7698L43.982 61.0346H37.7704L65.5582 3.0094V3.0094Z",
  fill: "#009035"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M73.6699 3.0094H79.8815L52.0943 61.0346H45.8822L73.6699 3.0094V3.0094Z",
  fill: "#009035"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.7814 3.0094H87.9936L60.2058 61.0346H53.9942L81.7814 3.0094V3.0094Z",
  fill: "#009035"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M89.8935 3.0094H96.105L68.3173 61.0346H62.1058L89.8935 3.0094V3.0094Z",
  fill: "#009035"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.0052 3.0094H104.217L76.4296 61.0346H70.2179L98.0052 3.0094V3.0094Z",
  fill: "#009035"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M106.117 3.0094H112.329L84.541 61.0346H78.3294L106.117 3.0094Z",
  fill: "#009035"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.229 3.0094H120.44L92.653 61.0346H86.4408L114.229 3.0094V3.0094Z",
  fill: "#009035"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M122.341 3.0094H128.552L100.765 61.0346H94.5531L122.341 3.0094V3.0094Z",
  fill: "#009035"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M130.453 3.0094H136.665L108.877 61.0346H102.665L130.453 3.0094V3.0094Z",
  fill: "#009035"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M141.839 3.0094H148.051L120.264 61.0346H114.053L141.839 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.952 3.0094H156.163L128.375 61.0346H122.164L149.952 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M158.063 3.0094H164.274L136.487 61.0346H130.276L158.063 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M166.175 3.0094H172.386L144.599 61.0346H138.387L166.175 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M174.287 3.0094H180.498L152.71 61.0346H146.499L174.287 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M182.398 3.0094H188.61L160.823 61.0346H154.611L182.398 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M190.51 3.0094H196.722L168.934 61.0346H162.723L190.51 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M198.622 3.0094H204.834L177.046 61.0346H170.834L198.622 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M206.733 3.0094H212.946L185.158 61.0346H178.946L206.733 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M214.846 3.0094H221.058L193.27 61.0346H187.058L214.846 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M222.957 3.0094H229.169L201.382 61.0346H195.169L222.957 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M231.069 3.0094H237.281L209.493 61.0346H203.282L231.069 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M239.181 3.0094H245.392L217.605 61.0346H211.393L239.181 3.0094V3.0094Z",
  fill: "#E30016"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M184.619 33.6115C184.619 27.6082 186.271 22.8633 189.575 19.3779C192.87 15.8923 197.351 14.1451 203.005 14.1451C208.677 14.1451 213.182 15.8923 216.521 19.3865C219.85 22.8889 221.519 27.6253 221.519 33.6115C221.519 39.6067 219.85 44.3437 216.521 47.8455C213.182 51.3397 208.677 53.0873 203.005 53.0873C197.351 53.0873 192.87 51.3397 189.575 47.8541C186.271 44.3691 184.619 39.6241 184.619 33.6115ZM194.174 33.6115C194.174 37.3801 194.932 40.2661 196.456 42.2705C197.98 44.2832 200.161 45.2852 203.005 45.2852C205.867 45.2852 208.064 44.2832 209.605 42.2705C211.146 40.2661 211.913 37.3801 211.913 33.6115C211.913 29.869 211.146 26.9828 209.605 24.9704C208.064 22.9573 205.867 21.9473 203.005 21.9473C200.161 21.9473 197.98 22.9492 196.456 24.9618C194.932 26.9657 194.174 29.8519 194.174 33.6115ZM150.938 52.06V15.1042H167.757C172.014 15.1042 175.26 16.0971 177.482 18.0758C179.713 20.0629 180.829 22.9236 180.829 26.6661C180.829 30.5967 179.73 33.6115 177.533 35.7101C175.335 37.8082 172.177 38.8613 168.055 38.8613H160.39V52.06H150.938V52.06ZM160.39 31.4109H166.632C168.327 31.4109 169.579 31.0505 170.388 30.3227C171.197 29.5953 171.597 28.4645 171.597 26.9486C171.597 25.476 171.18 24.3707 170.337 23.6428C169.494 22.915 168.224 22.5556 166.53 22.5556H160.39V31.4109ZM103.833 52.06V15.1042H116.787L121.624 33.089C122.058 34.6825 122.45 36.223 122.8 37.7224C123.149 39.2217 123.455 40.6768 123.72 42.0993C124.034 40.5914 124.391 39.0163 124.792 37.3716C125.192 35.7181 125.652 33.9543 126.164 32.0619L130.728 15.1042H143.656V52.06H135.071V35.676C135.071 34.5205 135.096 32.9012 135.156 30.8198C135.216 28.7385 135.301 26.3323 135.421 23.6087L128.36 52.06H119.027L112.12 23.6087C112.239 26.8884 112.324 29.8348 112.392 32.4555C112.461 35.0671 112.495 37.1145 112.495 38.5878V52.06H103.833ZM76.965 15.1042H87.244L100.214 52.06H90.1139L87.8653 45.2852H75.5939L73.4905 52.06H63.7392L76.965 15.1042V15.1042ZM77.8334 37.6289H85.8735L81.777 24.8846L77.8334 37.6289ZM61.891 39.1097C61.261 43.5459 59.5236 46.9807 56.6876 49.4217C53.8516 51.8621 50.1899 53.0873 45.7018 53.0873C40.3282 53.0873 35.9939 51.3226 32.6977 47.7938C29.402 44.2652 27.7583 39.6241 27.7583 33.869C27.7583 27.8823 29.4359 23.1033 32.783 19.5405C36.1381 15.9777 40.6263 14.1963 46.2469 14.1963C50.7005 14.1963 54.3456 15.3785 57.1647 17.7334C59.9837 20.0885 61.5934 23.309 61.9932 27.394H53.1623C52.7275 25.6209 51.9099 24.2848 50.7005 23.3949C49.5002 22.4954 47.9158 22.0497 45.9488 22.0497C43.326 22.0497 41.2392 23.0947 39.7153 25.1843C38.182 27.2743 37.4159 30.1344 37.4159 33.7656C37.4159 37.3801 38.1396 40.1889 39.5869 42.1847C41.0351 44.1804 43.0705 45.1823 45.7018 45.1823C47.8142 45.1823 49.5087 44.6597 50.7779 43.6233C52.0551 42.5876 52.8467 41.0799 53.1623 39.1097H61.891V39.1097Z",
  fill: "white"
});

function SvgCampo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 65,
    viewBox: "0 0 250 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampo);
export default __webpack_public_path__ + "static/media/campo.b89d3d14.svg";
export { ForwardRef as ReactComponent };